  import React, { useState, useEffect, useContext } from 'react';
  import {
    Box,
    Grid,
    Typography,
    ToggleButton,
    ToggleButtonGroup,
    IconButton,
    Tooltip,
    Modal,
    CircularProgress
  } from '@mui/material';
  import AddIcon from '@mui/icons-material/Add';
  import CustomCard from '../../components/UIComponents/CustomCard';
  import CustomTypography from '../../components/UIComponents/CustomTypography';
  import theme from '../../assets/theme';
  import LegendFilterGroup from '../../components/UIComponents/LegendFilterGroup';
  import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
  import GridViewIcon from '@mui/icons-material/GridView';
  import HeaderComponent from '../../components/Header';
  import InfoIcon from '@mui/icons-material/Info';
  import OccupiedPopup from './components/OccupiedPopup';
  import VacantPopup from './components/VacantPopup';
  import AddRoundedIcon from '@mui/icons-material/AddRounded';
  import { useLocation, useNavigate } from 'react-router-dom';
  import { fetchRoomBlockingList, fetchRoomList, fetchRoomTypes, getReportData, updateRoom } from "../../service/network";
  import { AuthContext } from '../../context/auth.context';
  import { useLoading } from '../../context/loading.context';
  import { useNotification } from '../../context/notification.context';
  import moment from 'moment';
  import CalendarView from './HotelBookingTimeline';
  import { mergeReportData } from '../../helpers/functions';

  const mainStatuses = [
    { label: 'Occupied', value: 'Occupied', color: theme.palette.red.main },
    { label: 'Vacant', value: 'Vacant', color: theme.palette.green.main },
    // { label: 'Due Check In', value: 'Due Check In', color: theme.palette.blue.main }
  ];

  const subStatuses = [
    { label: 'Clean', value: 'Clean' },
    { label: 'Dirty', value: 'Dirty' },
    { label: 'Room Care', value: 'Room Care' },
    { label: 'Inspect', value: 'Inspect' }
  ];

  const countRoomsByStatus = (rooms, status, isMainStatus) => {
    if (status === 'All') return rooms.length;
    return rooms.filter(room =>
      isMainStatus ? room.status === status : room.condition === status
    ).length;
  };

  export default function FrontDesk() {
    const [selectedType, setSelectedType] = useState('All');
    const [selectedMainStatus, setSelectedMainStatus] = useState('All');
    const [selectedSubStatus, setSelectedSubStatus] = useState('All');
    const [view, setView] = useState('grid');
    const [selectedRoom, setSelectedRoom] = useState(null);
    const [openOccupiedDialog, setOpenOccupiedDialog] = useState(false);
    const [openVacantDialog, setOpenVacantDialog] = useState(false);
    const [rooms, setRooms] = useState([]);
    const [roomTypes, setRoomTypes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [ckinrooms, setDueInRooms] = useState([]);
    const [ckoutrooms, setDueOutRooms] = useState([]);
    const navigate = useNavigate();
    const { selLocation } = useContext(AuthContext);
    const { showLoader, hideLoader } = useLoading();
    const { showNotification } = useNotification();
    const [showCalendarView, setShowCalendarView] = useState(false);
    const [blockList, setBlockList] = useState([]);


    const fetchRoomBlocking = async () => {
      try {
        showLoader();
        const currentDate = moment().format("YYYY-MM-DD");
        const filterConditions = [
          ['from_date', '<=', currentDate],
          ['to_date', '>=', currentDate]
        ];
        const roomBlockingParams = {
          doctype: 'Room Blockings',
          fields: JSON.stringify(["name", "room"]),
          filters: JSON.stringify(filterConditions),
        };
        const response = await fetchRoomBlockingList(roomBlockingParams);
        console.log("Api Response", response.data.message);
        if (response.data.message && (!Array.isArray(response.data.message))) {
          let merge_blockingList = mergeReportData(response.data.message.keys, response.data.message.values);
          setBlockList(merge_blockingList);
          console.log("merge_blockingList", merge_blockingList);
        } else {
          setBlockList([]);
        }
        console.log("RoomBlockingResponse", response.data.message);

      } catch (error) {
        showNotification('error', 'Error', error.message);
      } finally {
        hideLoader();
      }
    };

    const blockedRoomIds = blockList.map(b => b.room);
    console.log("blockRoomIds", blockedRoomIds);

    const loadRoomTypes = async () => {
      try {
        const params = {
          doctype: 'Room Type',
          fields: JSON.stringify(["name", "room_type"])
        };
        const res = await fetchRoomTypes(params);
        const uniqueRoomTypes = [...new Set(res.data.message.values.map(item => item[1]))];
        const formattedRoomTypes = [
          { label: 'All', value: 'All' },
          ...uniqueRoomTypes.map(type => ({ label: type, value: type }))
        ];
        setRoomTypes(formattedRoomTypes);
      } catch (err) {
        console.error("Failed to fetch room types", err);
        // Fallback to default types if API fails
        setRoomTypes([
          { label: 'All', value: 'All' },
          { label: 'Standard', value: 'Standard' },
          { label: 'Deluxe', value: 'Deluxe' },
          { label: 'Executive', value: 'Executive' }
        ]);
      }
    };

    const fetchDueCheckInReservations = async () => {
      try {
        let params = {
          doctype: "Reservation",
          fields: ["name", "room"],
          filters: [["from_date", "<=", moment().format("YYYY-MM-DD")], ["to_date", ">=", moment().format("YYYY-MM-DD")], ["status", "not in", ["Cheked-In", "Cancelled"]]]
        }
        let res = await getReportData(params);
        let temp = [];
        for (let ab of res.data.message?.values) {
          temp.push(ab[1]);
        }
        setDueInRooms(temp);
      } catch (err) {
        console.log(err);
      }
    }

    const fetchDueCheckOutReservations = async () => {
      try {
        let params = {
          doctype: "Reservation",
          fields: ["name", "room"],
          filters: [["to_date", "<=", moment().format("YYYY-MM-DD")], ["status", "in", ["Cheked-In"]]]
        }
        let res = await getReportData(params);
        let temp = [];
        for (let ab of res.data.message?.values) {
          temp.push(ab[1]);
        }
        setDueOutRooms(temp);
      } catch (err) {
        console.log(err);
      }
    }

  
    const fetchRooms = async () => {
      try {
        setLoading(true);
  
        const roomListParams = {
          doctype: 'Room',
          fields: JSON.stringify(["room_name", "type", "status", "info", "maintenance_issues", "name", "reservation"]),
          filters: JSON.stringify({ company: selLocation[0] }),
        };
  
        const response = await fetchRoomList(roomListParams);
  
        const roomData = response.data.message.values
          .map(room => ({
            type: room[1],
            typeName: room[1],
            number: room[0],
            status: room[2],
            condition: room[3],
            maintenance_issues: room[4],
            id: room[5],
            reservation: room[6],
            showInfoIcon: (room[4] > 0),
            guestName: room[2] === 'Occupied' ? `Guest ${room[0]}` : '',
            dueCheckIn: room[2] === 'Due Check In'
              ? new Date(Date.now() + 86400000).toLocaleDateString('en-GB')
              : ''
          })).sort((a, b) => a.number.localeCompare(b.number));
  
        console.log("Framed room", roomData);
        setRooms(roomData);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };
  
    useEffect(() => {
      loadRoomTypes();
      fetchRooms();
      fetchDueCheckInReservations();
      fetchDueCheckOutReservations();
      fetchRoomBlocking();
    }, []);

    const handleRoomClick = (room) => {
      console.log("clicked rowDeetails", room);
      setSelectedRoom(room);
      if (room.status === 'Occupied') {
        setOpenOccupiedDialog(true);
      } else if (room.status === 'Vacant' || room.status === 'Due Check In') {
        setOpenVacantDialog(true);
      }
    };

    const handleDialogClose = () => {
      setOpenOccupiedDialog(false);
      setOpenVacantDialog(false);
      setSelectedRoom(null);
    };

    const updateRoomDetails = async (data, selected) => {
      try {
        showLoader();
        const payload = {
          info: data
        }
        const response = await updateRoom(selected.id, payload);
        if (!response?.data) {
          throw new Error("Invalid response structure");
        }
        showNotification("success", "Updated", "Successfully Updated");
        console.log("API response:", response.data);
        fetchRooms();
        loadRoomTypes();

      } catch (error) {
        showNotification("error", "Error", "Failed to update maintainance");
        console.error("Failed to fetch  data:", error);
      } finally {
        hideLoader();
        handleDialogClose();
      }
    };

    const handleSave = async (data) => {
      console.log('Saved changes for room:', data);
      await updateRoomDetails(data, selectedRoom);

    };

    const filteredRooms = rooms.filter(room => {
      const typeMatch = selectedType === 'All' || room.type === selectedType;
      const mainStatusMatch = selectedMainStatus === 'All' || room.status === selectedMainStatus;
      const subStatusMatch = selectedSubStatus === 'All' || room.condition === selectedSubStatus;
      return typeMatch && mainStatusMatch && subStatusMatch;
    });
    const handleViewChange = (e, newView) => {
      if (newView !== null) { // Prevent deselecting all buttons
        setView(newView);
      }
    };

    return (
      <>
        {view === 'calendar' ? (
          <CalendarView onSwitchToGrid={() => setView('grid')} />
        ) : (
          <Box sx={{ width: '100%', p: 1.5, position: 'relative' }}>
            <HeaderComponent title="FrontDesk" />

            <CustomCard
              bgColor="light"
              shadow="lg"
              borderRadius="xxl"
              sx={{
                width: '100%',
                minHeight: 800,
                borderTopLeftRadius: 0,
              }}
            >
              {/* Title Section */}
              <Box
                position="relative"
                display="flex"
                justifyContent="center"
                alignItems="center"
                px={1}
                minHeight="60px"
              >
                <CustomTypography
                  variant="HeadingLarge"
                  color="dark"
                  sx={{
                    position: 'absolute',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    textAlign: 'center',
                  }}
                >
                  Room Status
                </CustomTypography>

                <Box
                  position="absolute"
                  right={16}
                  display="flex"
                  alignItems="center"
                  gap={1}
                >
                  <ToggleButtonGroup
                    value={view}
                    exclusive
                    onChange={handleViewChange}
                    sx={{
                      backgroundColor: '#f2f2f2',
                      borderRadius: '32px',
                      overflow: 'hidden',
                      boxShadow: '0px 4px 12px 0px #4A4C4E40',
                      '& .MuiToggleButton-root': {
                        border: 0,
                        borderRadius: '0 !important',
                        padding: '1px 15px',
                        color: '#000',
                        backgroundColor: 'light.main',
                        '&.Mui-selected': {
                          backgroundColor: 'secondary.main',
                        },
                        '&:hover': {
                          backgroundColor: '#e0e0e0',
                        },
                      },
                    }}
                  >
                    <ToggleButton value="grid">
                      <Tooltip title="Grid View">
                        <GridViewIcon sx={{ width: "20px" }} />
                      </Tooltip>
                    </ToggleButton>
                    <ToggleButton value="calendar">
                      <Tooltip title="Calendar View">
                        <CalendarMonthIcon sx={{ width: "20px" }} />
                      </Tooltip>
                    </ToggleButton>
                  </ToggleButtonGroup>

                </Box>
              </Box>

              {/* Filters Section */}
              <Box px={2.5}>
                {/* First Line - Room Type and Main Status */}
                <Box display="flex" justifyContent="space-between" alignItems="flex-start" flexWrap="wrap" gap={2}>
                  <Box flex={1} minWidth="280px" maxWidth="350px">
                    <LegendFilterGroup
                      title="Room Type"
                      items={roomTypes}
                      selected={selectedType}
                      onSelect={(value) => setSelectedType(value)}
                      showCount={false}
                      columns={4}
                      align="right"
                      getLabel={(item) => item.label}
                      getValue={(item) => item.value}
                    />
                  </Box>

                  <Box flex={1} minWidth="300px" maxWidth="600px" mt={-1.6}>
                    <LegendFilterGroup
                      items={mainStatuses}
                      selected={selectedMainStatus}
                      onSelect={(value) =>
                        setSelectedMainStatus((prev) => (prev === value ? 'All' : value))
                      }
                      showCount={true}
                      getCount={(status) => countRoomsByStatus(rooms, status, true)}
                      columns={4}
                      align="center"
                    />
                  </Box>
                </Box>
 
                {/* Second Line - Sub Status (aligned to right) */}
                <Box display="flex" justifyContent="flex-end" width="100%">
                  <Box flex={1} minWidth="300px" maxWidth="600px" mt={-4.2}>
                    <LegendFilterGroup
                      items={subStatuses}
                      selected={selectedSubStatus}
                      onSelect={(value) =>
                        setSelectedSubStatus((prev) => (prev === value ? 'All' : value))
                      }
                      showCount={true}
                      getCount={(status) => countRoomsByStatus(rooms, status, false)}
                      columns={4}
                      align="center"
                    />
                  </Box>
                </Box>
              </Box>

              {/* Room Count */}
              <Box px={1} mt={1}>
                <Typography variant="body2" color="textSecondary">
                  Showing {filteredRooms.length} of {rooms.length} rooms
                </Typography>
              </Box>

              {/* Room Grid */}
              <Grid container spacing={2} mt={1} px={1}>
                {filteredRooms.length > 0 ? (
                  filteredRooms.map((room, index) => (
                    <Grid item xs={12} sm={6} md={4} lg={1.2} xl={1.2} key={index}>
                      <Box
                        onClick={() => handleRoomClick(room)}
                        sx={{
                          borderRadius: 2,
                          minWidth: { xs: 180, sm: 'auto' },
                          maxWidth: 240,
                          p: 1.5,
                          backgroundColor:
                            room.status === 'Occupied'
                              ? theme.palette.red.light10
                              : blockedRoomIds.includes(room.id)
                                ? "#4A4C4E1A" : room.status === 'Vacant' && room.condition === 'Dirty' && !blockedRoomIds.includes(room.id)
                                  ? theme.palette.orange.light : theme.palette.green.light10,
                          border: `2px solid ${room.status === 'Occupied'
                            ? theme.palette.red.light50
                            : blockedRoomIds.includes(room.id)
                              ? "rgba(74, 76, 78, 0.5)"
                              : room.status === 'Vacant' && room.condition === 'Dirty' && !blockedRoomIds.includes(room.id)
                                ? theme.palette.orange.main : theme.palette.green.light50}`,
                          boxShadow: room.status === 'Due Check In'
                            ? '0px 4px 12px 0px rgba(0, 114, 245, 0.25)'
                            : '0px 4px 12px 0px rgba(74, 76, 78, 0.25)',
                          cursor: 'pointer',
                          '&:hover': {
                            boxShadow: room.status === 'Occupied'
                              ? '0px 4px 12px 0px rgba(245, 0, 0, 0.3)'
                              : blockedRoomIds.includes(room.id)
                                ? '0px 4px 12px 0px rgba(0, 0, 0, 0.3)'
                                : room.status === 'Vacant' && room.condition === 'Dirty' && !blockedRoomIds.includes(room.id)
                                  ? '0px 4px 12px 0px rgba(255, 167, 86, 0.4)' : '0px 4px 12px 0px rgba(0, 200, 83, 0.3)'

                          }
                        }}
                      >
                        {/* Room Type & Number - Single Line, No Wrap */}
                        <Box
                          display="flex"
                          flexDirection="column"
                          alignItems="flex-start"
                          sx={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            position: 'relative'
                          }}
                        >

                          <Box sx={{ position: "absolute", top: 0, right: 0 }}>
                            <Box display="flex"
                              gap={0.5}
                              flexDirection="row">
                              {
                                (ckinrooms.includes(room.id)) && <Box
                                  sx={{
                                    width: 14,
                                    height: 14,
                                    borderRadius: '50%',
                                    backgroundColor: theme.palette.green.main,
                                  }}
                                />
                              }
                              {
                                (ckoutrooms.includes(room.id)) && <Box
                                  sx={{
                                    width: 14,
                                    height: 14,
                                    borderRadius: '50%',
                                    backgroundColor: theme.palette.red.main,
                                  }}
                                />}
                            </Box>
                          </Box>
                          <Typography
                            variant="buttonL"
                            sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
                          >{blockedRoomIds.includes(room.id)}
                            {room.number}
                          </Typography>
                          <Typography
                            variant="buttonS"
                            sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
                          >
                            {room.type}
                          </Typography>

                        </Box>

                        {/* Room Status */}
                        <Box
                          mt={1}
                          ml={-0.5}
                          p={0.2}
                          display="inline-block"
                          bgcolor={
                            room.status === 'Occupied'
                              ? theme.palette.red.main
                              : blockedRoomIds.includes(room.id)
                                ? theme.palette.secondarygray.main : room.status === 'Vacant' && room.condition === "Dirty" && !blockedRoomIds.includes(room.id)
                                  ? theme.palette.orange.main : theme.palette.green.main
                          }
                          color="white"
                          borderRadius={1}
                          fontSize={12}
                        >
                          <Typography variant='buttonS' p={0.5}>
                            {room.status}
                          </Typography>
                        </Box>

                        {/* Room Condition & Info Icon */}
                        <Box display="flex" justifyContent="space-between" alignItems="center" mt={1}>
                          <Typography variant='miniText' sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {room.condition}
                          </Typography>
                          {room.showInfoIcon && (
                            <Tooltip title={`Room ${room.number} has ${room.maintenance_issues} issues Pending`}>
                              <InfoIcon sx={{ fontSize: 18, color: "#FFA756" }} />
                            </Tooltip>
                          )}
                        </Box>
                      </Box>
                    </Grid>
                  ))
                ) : (
                  <Box width="100%" textAlign="center" p={4}>
                    <Typography>No rooms match the selected filters</Typography>
                  </Box>
                )}
              </Grid>

            </CustomCard>

            {/* Fixed Floating Add Button */}
            <IconButton
              onClick={() => navigate('/reservation')}
              sx={{
                position: 'fixed',
                bottom: 32,
                right: 32,
                backgroundColor: "lightblue.main",
                color: 'white',
                border: '3px solid var(--Primary-Blue-MB, #27394D)',
                borderRadius: '50%',
                width: 56,
                height: 56,
                zIndex: 1000,
                '&:hover': {
                  backgroundColor: theme.palette.light.main,
                }
              }}
            >
              <AddRoundedIcon sx={{ color: theme.palette.primary.main, fontSize: 36 }} />
            </IconButton>

            {/* Occupied Dialog */}
            <Modal open={openOccupiedDialog} onClose={handleDialogClose}>
              <Box
                onClick={handleDialogClose}
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100vh',
                  bgcolor: 'rgba(0, 0, 0, 0.5)',
                }}
              >
                <Box onClick={(e) => e.stopPropagation()}>
                  {selectedRoom && (
                    <OccupiedPopup
                      onClose={handleDialogClose}
                      onSave={handleSave}
                      room={selectedRoom}
                    />
                  )}
                </Box>
              </Box>
            </Modal>

            {/* Vacant Dialog */}
            <Modal open={openVacantDialog} onClose={handleDialogClose}>
              <Box
                onClick={handleDialogClose}
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100vh',
                  bgcolor: 'rgba(0, 0, 0, 0.5)',
                }}
              >
                <Box onClick={(e) => e.stopPropagation()}>
                  {selectedRoom && (
                    <VacantPopup
                      onClose={handleDialogClose}
                      onSave={handleSave}
                      roomNo={`${selectedRoom.type}-${selectedRoom.number}`}
                      roomType={selectedRoom.typeName}
                      dueCheckIn={selectedRoom.dueCheckIn}
                      maintenance={selectedRoom.maintenance_issues}
                      statusInfo={selectedRoom.condition}
                    />
                  )}
                </Box>
              </Box>
            </Modal>
          </Box>
        )}
      </>
    );
  }

